import './createGroup.scss';
var htmlContent = require('./createGroup.html');
import { BaseModalContent } from '../../shared/components/base-modal-content';
import { HttpService } from '../../core/http/http';
import { Validator } from '../../core/validator/validator';

const renderMarkup = () => htmlContent;

export class CreateGroupComponent extends BaseModalContent {
  constructor(options, estructuradoEnUte, textSubtitle) {
    super(renderMarkup());
    this.value = null;
    this.options = options;
    this.estructuradoEnUte = estructuradoEnUte;
    this.textSubtitle = textSubtitle;
  }

  onCreated() {
    this.init();
  }

  init() {
    this.parentModal.container.find('.cancel').click(() => this.cancel());
    this.parentModal.container.find('.create').click(() => this.create());
    if (!this.estructuradoEnUte) {
      this.parentModal.container.find('.participation-group').hide();
      this.parentModal.container.find('.subtitle').text(this.textSubtitle);
    }
    this.validator = new Validator(this.parentModal.container);
    this.validator.validate();
  }

  cancel() {
    this.value = null;
    this.parentModal.close();
  }

  create() {
    if (!this.validator.isValid) {
      return;
    }

    this.value = {
      name: this.parentModal.container.find('.name').val(),
      participation: this.parentModal.container.find('.participation').val()
    };
    this.parentModal.close();
  }

  get result() {
    return this.value;
  }
}
